<template>
  <header class="header">
    <h1>Cruise Line Analytics</h1>
    <p class="subtitle">eGuide Data</p>
  </header>
</template>


<style scoped>
.header {
  text-align: center;
  margin-bottom: 1rem;
}

.header h1 {
  font-size: 1.8rem;
  font-weight: 700;
  color: #111827;
}

.subtitle {
  color: #6b7280;
  font-size: 0.85rem;
}
</style>